import type { DashboardFilters } from "@nexus/widget-sdk";

/**
 * Shared filter extraction utilities for data source resolvers.
 *
 * These are host-platform primitives — domain resolvers consume them but do
 * not modify them. Any change here affects every resolver simultaneously.
 */

export function getFilterValue(filters: DashboardFilters, field: string): string | undefined {
  const filter = filters.dataFilters.find((item) => item.field === field);

  if (!filter) return undefined;

  if (Array.isArray(filter.value)) {
    const [firstValue] = filter.value;
    return firstValue == null ? undefined : String(firstValue);
  }

  return filter.value == null ? undefined : String(filter.value);
}

export function getFilterValues(filters: DashboardFilters, field: string): string[] | undefined {
  const values = filters.dataFilters
    .filter((filter) => filter.field === field)
    .flatMap((filter) => (Array.isArray(filter.value) ? filter.value : [filter.value]))
    .filter(
      (value): value is string | number => typeof value === "string" || typeof value === "number",
    )
    .map(String);

  return values.length > 0 ? [...new Set(values)].sort() : undefined;
}

export function getTenantIds(filters: DashboardFilters): number[] | undefined {
  return filters.tenantIds.length > 0 ? filters.tenantIds.map(Number) : undefined;
}
